import { apiSlice } from "../../../app/apiSlice";
import configUrls from "../../../config/configUrls";
import { ProcessoSetores, ProcessoSetoresList, ProcessoPrazoDTO } from "../../../types/processo/ProcessoSetoresDTO";



const endpointUrl = configUrls.PROCESSO_EP

function prazoProcesso(obj: ProcessoPrazoDTO) {
    return {
        url: `${endpointUrl}/prazo/create`,
        method: "POST",
        body: obj,
    }

}

function cancelarprazo({ id }: { id: string }) {
    return {
        url: `${endpointUrl}/prazo/${id}`,
        method: "DELETE",
    }
}

function getprazos({ id, search }: { id: string, search: string }) {

    if (!id) {
        // Se 'processo' for null/undefined ou não tiver 'id', não faz a chamada à API.
        return {
            url: '',
            method: ''
        };
    }


    return {
        url: `${endpointUrl}/prazos/${id}?search=${search}`,
        method: "GET",
    }
}

function getprazo(id: string) {
    if (!id) {
        // Se 'processo' for null/undefined ou não tiver 'id', não faz a chamada à API.
        return {
            url: '',
            method: ''
        };
    }

    return {
        url: `${endpointUrl}/prazo/${id}`,
        method: "GET",
    }
}

function deleteprazo({ id }: { id: string }) {
    return {
        url: `${endpointUrl}/prazo/${id}`,
        method: "DELETE",
    }
}

export const processoPrazoApiSlice = apiSlice.injectEndpoints({
    endpoints: ({ query, mutation }) => ({


        getPrazos: query<ProcessoSetoresList[], { id: string, search: string }>({

            query: getprazos,
            providesTags: ["ProcessoPrazo"],
        }),

        getPrazo: query<ProcessoSetores, string>({
            //query: (id) => `${endpointUrl}/ciencia/${id}`,
            query: getprazo,
            providesTags: ["ProcessoPrazo"],
        }),

        prazoProcesso: mutation<void, ProcessoPrazoDTO>(
            {
                query: prazoProcesso,
                invalidatesTags: ["ProcessoPrazo"]
            }),
        deletePrazo: mutation<void, { id: string }>(
            {
                query: deleteprazo,
                invalidatesTags: ["ProcessoPrazo"],
            }),


    }),

});
export const {
    useGetPrazosQuery,
    useGetPrazoQuery,
    usePrazoProcessoMutation,
    useDeletePrazoMutation,

} = processoPrazoApiSlice;
